// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiSelectBox_container{
    border: 1px solid #ced4da !important; 
    background-color: #fff !important;   
    border-radius: 5px;
}
.MultiSelectBox_container_disabled{
    border: 1px solid #ced4da !important; 
    background-color: #e9ecef !important;   
    border-radius: 5px;
}

.btn.show{
    background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Rag/NewRagForm.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".MultiSelectBox_container{\n    border: 1px solid #ced4da !important; \n    background-color: #fff !important;   \n    border-radius: 5px;\n}\n.MultiSelectBox_container_disabled{\n    border: 1px solid #ced4da !important; \n    background-color: #e9ecef !important;   \n    border-radius: 5px;\n}\n\n.btn.show{\n    background-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
